import { schema } from 'normalizr';

import createResource from './createResource';
import facilitiesResource from './facilitiesResource';
import messagesResource from './messagesResource';
import patientsResource from './patientsResource';
import { ChatActivity } from './types';
import usersResource from './usersResource';

const chatActivitiesResource = createResource<ChatActivity>({
  key: 'chatActivities',
  url: '/chatActivities',
  fetchPageUrl: '/chatActivities',
  lookups: {
    assignee: usersResource,
    facilities: { ...facilitiesResource, schema: new schema.Array(facilitiesResource.schema) },
    lastMessage: messagesResource,
    patient: patientsResource,
    previousAssignee: usersResource,
    to: usersResource,
  },
});

export default chatActivitiesResource;
